<template functional>
  <div>
    <alter-request
      :requester="{ id: props.item.id, type: 'Container', attr: 'chassis_no' }"
      :size="18"
    >
      {{ props.item.chassis_no }}
    </alter-request>
    <template
      v-for="o in props.item.transports
        .map((t) => t.operations)
        .flat()
        .filter((o) => o.mode)"
    >
      <alter-request
        :requester="{ id: o.id, type: 'Operation', attr: 'chassis_no' }"
        :size="18"
        :key="o.id"
      >
        <div class="tag">{{ o.chassis_no }}</div>
      </alter-request>
    </template>
  </div>
</template>

<script>
export default {
  name: "drayage-chassis-no",
  functional: true,
  props: {
    item: Object,
    options: Object,
  },
};
</script>

<style scoped>
/* Add any component-specific styles here */
</style>
